// PROPOSITO: decidir quien entra donde. Nada mas: no pinta contenido.
// DEPENDENCIAS: src/store/auth, react-router-dom.
// NO OBVIO: esto solo decide QUE SE PINTA. La proteccion real vive en RLS. Si alguien manipula el
// store y se pone rol entrenadora, vera el armazon del panel y ni una fila de datos ajenos, porque
// la base no se los devuelve. Una proteccion que se puede saltar hablandole a la API no protege.

import { Navigate, Outlet } from 'react-router-dom'
import { usarAuth } from '@/store/auth'
import type { Rol } from '@/types/dominio'

interface Props {
  permitidos: Rol[]
}

export function Guard({ permitidos }: Props) {
  const perfil = usarAuth(e => e.perfil)
  const cargando = usarAuth(e => e.cargando)

  if (cargando) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sobre-tenue">
        Abriendo tu sesión…
      </div>
    )
  }

  if (!perfil) return <Navigate to="/entrar" replace />
  if (!permitidos.includes(perfil.rol)) return <Navigate to="/" replace />

  return <Outlet />
}
